const isIPadDevice = () =>
  navigator.vendor === 'Apple Computer, Inc.' && navigator.maxTouchPoints > 0

const isIOS = (operatingSystem: string) =>
  operatingSystem === 'iOS' || isIPadDevice()

export { isIOS }
